<ion-content ion-no-padding ion-text-center class="background">
    <ion-grid>
        <ion-row class="header">
            <ion-col>ShuttleNomix</ion-col>
        </ion-row>
        <ion-row class="subheader">
            <ion-col>Shuttle Automation</ion-col>
        </ion-row>
        <ion-row class="subheader">
            <ion-col>For Car Dealerships</ion-col>
        </ion-row>
    </ion-grid>

    <br />
    @if (showLoginDiv === true) {
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-card class="default">
                        <ion-card-header>
                            <div class="title" data-test="title1">Application Login</div>
                            <div class="version" data-test="version">Version {{vm.version}}</div>
                        </ion-card-header>

                        <form name="form" (ngSubmit)="f.form.valid && onLoginClick(f)" #f="ngForm" novalidate>
                            <ion-card-content class="ion-no-padding">
                                <ion-list class="ion-no-padding" lines="none">
                                    <ion-item>
                                        <ion-label class="ion-text-wrap" position="stacked">Email Address</ion-label>
                                        <ion-input type="email" [(ngModel)]="user.email" data-test="email1"
                                                name="email" #email="ngModel" required
                                                [ngClass]="{ 'is-invalid': f.submitted && email.invalid }">
                                        </ion-input>
                                        @if (submitted && email.invalid) {
                                            <div data-test="emailErr">
                                                <div class="validationErrorMsg">Enter a properly formatted email address.</div>
                                            </div>
                                        }
                                    </ion-item>
                                    <ion-item>
                                        <ion-label class="ion-text-wrap" position="stacked">Password</ion-label>
                                        <ion-input type="password" [(ngModel)]="user.password" data-test="password"
                                                name="password" #password="ngModel" required
                                                [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" >
                                        </ion-input>
                                     
                                        <ion-buttons class="itemButtons" slot="end">
                                            <ion-button class="itemButton" color="primary" expand="full" fill="solid" 
                                                    id="eye" (click)="onEyeClick()" data-test="eye">
                                                <ion-icon name="eye" slot="icon-only"></ion-icon>
                                            </ion-button>
                                        </ion-buttons>
                                        @if (submitted && password.invalid) {
                                            <div data-test="passwordErr">
                                                <div class="validationErrorMsg">Password must be at leasts 6 charcters.</div>
                                            </div>
                                        }
                                    </ion-item>

                                    <ion-button color="primary" expand="block" [disabled]="!f.valid"
                                            class="loginBtn ion-padding" #loginButton
                                            (click)="onLoginClick(f)" data-test="loginBtn">
                                        {{vm.loginText}}
                                    </ion-button>
                                </ion-list>
                            </ion-card-content>
                        </form>
                    </ion-card>
                </ion-col>
            </ion-row>

            <ion-row class="centerLink">
                <ion-col>
                    <a (click)="onToggleLoginVisibility()" data-test="forgotLink">Forgot Password?</a>
                </ion-col>
            </ion-row>
        </ion-grid>
    }

    <ion-list lines="none">
        @if (showLoginDiv === false) {
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <ion-card class="default">
                            <ion-card-header>
                                <div class="title" data-test="title2">Forgot Password</div>
                            </ion-card-header>
                            <ion-card-content class="ion-no-padding">
                                <ion-list class="ion-no-padding">
                                    <ion-item>
                                        <ion-label class="ion-text-wrap" position="stacked">Email Address</ion-label>
                                        <ion-input type="text" [(ngModel)]="user.email" data-test="email2"></ion-input>
                                    </ion-item>

                                    <ion-button expand="block" class="forgotBtn ion-padding"
                                        data-test="resetBtn" (click)="onResetPasswordClick()">Send Password Reset Email</ion-button>
                                </ion-list>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>

                <ion-row class="centerLink">
                    <ion-col>
                        <a (click)="onToggleLoginVisibility()" data-test="backToLogin">Back to Login</a>
                    </ion-col>
                </ion-row>
            </ion-grid>
        }
    </ion-list>
</ion-content>